import { Box, Chip, Divider, Paper, Stack, Typography } from "@mui/material";
import { InvalidDataReportDto } from "../../../api/psc";
import {
    InvalidDataReportStatusInfoList,
    InvalidDataReportTypeInfoList,
} from "../../../constants/InvalidDataReportContants";
import { toJalaliDate } from "../../../utils/date";

export default function InvalidDataReportItem(props: {
    invalidDataReport: InvalidDataReportDto;
}) {
    const idr = props.invalidDataReport;

    const statusInfo = InvalidDataReportStatusInfoList.find(
        (i) => i.id === idr.status
    );
    const typeTitle = InvalidDataReportTypeInfoList.find(
        (i) => i.id === idr.type
    );

    return (
        <Paper sx={{ p: 2 }}>
            <Stack spacing={1.5}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Chip
                        size="small"
                        color="error"
                        variant="outlined"
                        label={typeTitle.title}
                    />
                    <Typography color="text.secondary">برای پروژه</Typography>
                    <Typography color="primary">{idr.projectHashId}</Typography>

                    <Box sx={{ flexGrow: 1 }} />

                    <Chip
                        size="small"
                        label={statusInfo.title}
                        sx={{
                            bgcolor: statusInfo.color,
                            mr: 0.5,
                            color: "white",
                        }}
                    />
                </Stack>

                <Divider />

                {idr.notes && (
                    <Box>
                        <Typography component="span" color="primary">
                            توضیحات کاربر:
                        </Typography>

                        <Typography component="span" color="text.secondary">
                            {idr.notes ?? "بدون توضیحات"}
                        </Typography>
                    </Box>
                )}

                {idr.responseNotes && (
                    <Box>
                        <Typography component="span" color="primary">
                            پاسخ اپراتور:
                        </Typography>

                        <Typography component="span" color="text.secondary">
                            {idr.responseNotes ?? "بدون توضیحات"}
                        </Typography>
                    </Box>
                )}

                <Typography fontSize="smaller" color="text.secondary">
                    تاریخ ثبت: {toJalaliDate(idr.createDate)}
                </Typography>
            </Stack>
        </Paper>
    );
}
